const CIO_REGEX = /https?:\/\/.*?\.?customer\.io/;

export default function isCIODomain(value?: string) {
  return CIO_REGEX.test(value ?? '');
}
